import { render } from "./TenantColorPickerContextMenu.vue?vue&type=template&id=be189e24&scoped=true&ts=true"
import script from "./TenantColorPickerContextMenu.vue?vue&type=script&lang=ts"
export * from "./TenantColorPickerContextMenu.vue?vue&type=script&lang=ts"

import "./TenantColorPickerContextMenu.vue?vue&type=style&index=0&id=be189e24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be189e24"]])

export default __exports__